export enum RegexEnum {
	PasswordRegex = '^(?=.*\\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$',
	PhoneNumberRegexWithCode = '^(\\+91)[7-9][0-9]{9}$',
	Numeric = '^[0-9]*$',
	FloatNumbers = '^[+-]?\\d+(\\.\\d+)?$',
}
